export function formatTime12(t) {
  if (!t) return "";
  const m = /^(\d{1,2}):(\d{2})/.exec(String(t).trim());
  if (!m) return t;
  let h = parseInt(m[1], 10);
  const suffix = h >= 12 ? "PM" : "AM";
  h = h % 12 || 12;
  return `${h}:${m[2]} ${suffix}`;
}

export function formatTimeRange12(start, end) {
  const a = formatTime12(start);
  const b = formatTime12(end);
  if (a && b) return `${a} – ${b}`;
  return a || b || "";
}
